import React, { Component } from 'react';

const CDN = 'https://www.bk8thaifan.win/public/html/images/vip';
const CDN2 = 'https://baryon.million-edge.online/public/html/images/vip';

const tiers = [
  { key: 'bronze',   label: 'Bronze',   amount: '500,000',      img: `${CDN}/bronze.png`,   icon: `${CDN}/groupicon-Bronze.png`,   color: '#cd7f32' },
  { key: 'silver',   label: 'Silver',   amount: '1,000,000',    img: `${CDN}/silver.png`,   icon: `${CDN}/groupicon-Silver.png`,   color: '#c0c0c0' },
  { key: 'gold',     label: 'Gold',     amount: '3,000,000',    img: `${CDN}/gold.png`,     icon: `${CDN}/groupicon-Gold.png`,     color: '#ffd700' },
  { key: 'platinum', label: 'Platinum', amount: '5,000,000',    img: `${CDN}/platinum.png`, icon: `${CDN}/groupicon-Platinum.png`, color: '#e5e4e2' },
  { key: 'diamond',  label: 'Diamond',  amount: 'ได้รับคำเชิญ', img: `${CDN}/diamond.png`,  icon: `${CDN}/groupicon-Diamond.png`,  color: '#b9f2ff' },
];

const benefitRows = [
  {
    group: 'สิทธิ์บัญชี VIP',
    rows: [
      { label: 'ผู้จัดการบริการลูกค้าตลอด 24 ชั่วโมง',         values: ['ไม่', 'ได้รับสิทธิ์', 'ได้รับสิทธิ์', 'ได้รับสิทธิ์มาก', 'ได้รับสิทธิ์อันดับแรก'] },
      { label: 'ผู้จัดการบริการลูกค้าส่วนตัว',                   values: ['-', '-', '-', 'ได้รับสิทธิ์มาก', 'ได้รับสิทธิ์อันดับแรก'] },
      { label: 'ยอดถอนต่อการถอนสูงสุด',                          values: ['900,000', '1,250,000', '1,600,000', 'พิเศษ', 'พิเศษ'] },
      { label: '- ยอดถอนผ่านธนาคาร สูงสุดต่อวัน',               values: ['900,000', '800,000', '1,000,000', 'พิเศษ', 'พิเศษ'], sub: true },
      { label: '- ยอดถอนผ่าน Crypto สูงสุดต่อวัน',              values: ['900,000', '1,250,000', '1,600,000', 'พิเศษ', 'พิเศษ'], sub: true },
      { label: 'สิทธิ์เข้าร่วมกิจกรรมผ่านบัญชีประเภทดอลล่าร์', values: ['ลงทะเบียนได้', 'ลงทะเบียนได้', 'ลงทะเบียนได้', 'ทราบผลไวที่สุด', 'ทราบผลไวที่สุด'] },
    ]
  },
  {
    group: 'โบนัสพิเศษต่างๆ',
    rows: [
      { label: 'โบนัสตามเทศกาลต่างๆ',          values: ['มีโอกาส', 'มีโอกาส', 'ได้รับสิทธิ์', 'ได้รับสิทธิ์', 'ได้สิทธิ์อันดับแรก'] },
      { label: 'โบนัสพิเศษวันเกิด',              values: ['สูงสุด 7,200', 'สูงสุด 15,000', 'สูงสุด 23,000', 'สูงสุด 37,000', 'สูงสุด 50,000'] },
      { label: 'สิทธิ์การเข้าร่วมกิจกรรมต่างๆ', values: ['-', '-', 'มีโอกาสมาก', 'มีโอกาสมาก', 'ได้สิทธิ์อันดับแรก'] },
    ]
  },
  {
    group: 'คืนเงินพิเศษ',
    rows: [
      { label: 'คืนเงินรายวันคาสิโน',        values: ['0.20%', '0.30%', '0.40%', '0.50%', '0.80%'] },
      { label: 'PK8SPORTS คืนเงินรายวัน', values: ['0.40%', '0.50%', '0.60%', '0.70%', '0.80%'] },
      { label: 'คืนเงินรายวันกีฬา',          values: ['0.30%', '0.40%', '0.50%', '0.60%', '0.70%'] },
      { label: 'คืนเงินรายวันเกมตกปลา',      values: ['0.50%', '0.50%', '0.50%', '0.50%', '0.50%'] },
      { label: 'คืนเงินรายวันสล็อต',         values: ['0.60%', '0.60%', '0.70%', '0.80%', '1%'] },
    ]
  },
  {
    group: 'ของขวัญพิเศษ',
    rows: [
      { label: 'ของขวัญการเลื่อนระดับ',       values: ['ได้รับสิทธิ์', 'ได้รับสิทธิ์', 'ได้รับสิทธิ์', 'ได้รับสิทธิ์', 'ได้สิทธิ์อันดับแรก'] },
      { label: 'ของขวัญวันเกิดสุดหรูประจำปี', values: ['ได้รับสิทธิ์', 'ได้รับสิทธิ์', 'ได้รับสิทธิ์', 'ได้สิทธิ์อันดับแรก', '-'] },
      { label: 'ของขวัญตามเทศกาล',            values: ['-', 'ได้รับสิทธิ์', 'ได้รับสิทธิ์', 'ได้สิทธิ์อันดับแรก', '-'] },
    ]
  },
];

const upgradeRows = [
  { label: 'ยอดฝากสะสมภายในเดือน (เลื่อนระดับ)', values: ['500,000', '1,000,000', '3,000,000', '5,000,000', 'ได้รับคำเชิญ'] },
  { label: 'ยอดฝากสะสมรวม 3 เดือนย้อนหลัง (รักษาระดับ)', values: ['500,000', '1,000,000', '3,000,000', '5,000,000', 'ได้รับคำเชิญ'] },
];

const faqs = [
  { q: 'จะเป็นวีไอพีได้อย่างไร?',         a: 'สมาชิกต้องปฏิบัติตามข้อกำหนดการฝากขั้นต่ำที่กำหนดไว้ภายในระยะเวลาที่กำหนด หรือได้รับคำเชิญพิเศษจากทีมงาน PK8' },
  { q: 'จะรักษาระดับ VIP ได้อย่างไร?',    a: 'สมาชิกต้องรักษายอดฝากสะสมให้ถึงตามเกณฑ์ภายใน 3 เดือนย้อนหลัง เพื่อคงไว้ซึ่งระดับ VIP ของตนเอง' },
  { q: 'สามารถดาวน์เกรดระดับ VIP ได้หรือไม่?', a: 'หากสมาชิกไม่สามารถรักษายอดฝากตามเกณฑ์ได้ในช่วงเวลาที่กำหนด ระดับ VIP อาจถูกปรับลดลง ทีมงานจะแจ้งให้ทราบล่วงหน้า' },
  { q: 'สิทธิพิเศษ VIP มีอะไรบ้าง?',      a: 'ผู้จัดการบัญชีส่วนตัว โบนัสพิเศษ คืนเงินสูงขึ้น ของขวัญวันเกิด สิทธิ์เข้าร่วมกิจกรรมพิเศษ และอีกมากมาย' },
];

const s = {
  // section wrapper — ใช้ display ควบคุมผ่าน activeTab
  show: { display: 'block' },
  hide: { display: 'none' },
};

class VipPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'about',
      openFaq: null,
    };
  }

  sec(key) {
    // return display style ตาม activeTab
    return { display: this.state.activeTab === key ? 'block' : 'none' };
  }

  renderStars(n) {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} style={{ color: i < n ? '#f5a623' : '#555', fontSize: 14 }}>★</span>
    ));
  }

  renderBenefitsTable() {
    return (
      <div style={{ background: '#0a1628', padding: '56px 16px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>
                <th style={{ width: 240, padding: '12px 16px', textAlign: 'left', background: '#0d2348', borderBottom: '2px solid #1e3560' }} />
                {tiers.map(t => (
                  <th key={t.key} style={{ padding: '16px 12px', textAlign: 'center', background: '#0d2348', borderBottom: '2px solid #1e3560' }}>
                    <img src={t.icon} alt={t.label} style={{ width: 44, height: 44, display: 'block', margin: '0 auto 6px' }} />
                    <div style={{ color: t.color, fontWeight: 700, fontSize: 13 }}>{t.label}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {benefitRows.map((group, gi) => (
                <React.Fragment key={gi}>
                  <tr>
                    <td colSpan={6} style={{ padding: '10px 16px', background: '#0e2040', color: '#f5a623', fontWeight: 700, fontSize: 13, borderTop: '1px solid #1e3560' }}>
                      {group.group}
                    </td>
                  </tr>
                  {group.rows.map((row, ri) => (
                    <tr key={ri} style={{ background: ri % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent' }}>
                      <td style={{ padding: '10px 16px', color: row.sub ? '#8aaccc' : '#c8d6e5', borderBottom: '1px solid #1a2e50', paddingLeft: row.sub ? 28 : 16 }}>
                        {row.label}
                      </td>
                      {row.values.map((v, vi) => (
                        <td key={vi} style={{ padding: '10px 12px', textAlign: 'center', color: v === '-' ? '#3a5070' : '#e8f0fe', borderBottom: '1px solid #1a2e50', fontSize: 12 }}>
                          {v}
                        </td>
                      ))}
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // ════════════ MOBILE VIP (แยกจาก desktop) ════════════
  renderMobile() {
    const { activeTab, openFaq } = this.state;
    const tabs = [
      { key: 'about',    label: 'เกี่ยวกับ' },
      { key: 'upgrade',  label: 'ปรับระดับ' },
      { key: 'benefits', label: 'สิทธิประโยชน์' },
      { key: 'faq',      label: 'คำถามที่พบบ่อย' },
      { key: 'referral', label: 'แนะนำเพื่อน' },
    ];
    const tBtn = (key) => ({
      background: 'none', border: 'none', cursor: 'pointer', flex: '0 0 auto',
      padding: '13px 14px', fontSize: 14, fontFamily: 'inherit', whiteSpace: 'nowrap',
      color: activeTab === key ? '#f5a623' : '#8aaccc',
      borderBottom: activeTab === key ? '2px solid #f5a623' : '2px solid transparent',
      fontWeight: activeTab === key ? 700 : 400,
    });

    return (
      <div style={{ background: '#0a1628', minHeight: '100vh', fontFamily: 'Noto Sans Thai, sans-serif', color: '#fff' }}>
        {/* Hero */}
        <div style={{ position: 'relative', minHeight: 170, overflow: 'hidden', background: 'linear-gradient(135deg,#051030,#0d2348 60%,#1a3a6e)' }}>
          <img src={`${CDN2}/top-banner.jpg`} alt="VIP" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.7 }} />
          <div style={{ position: 'relative', zIndex: 2, padding: '34px 20px' }}>
            <div style={{ fontSize: 12, color: '#f5a623', letterSpacing: 2, marginBottom: 4 }}>Supreme</div>
            <h1 style={{ fontSize: 26, fontWeight: 800, margin: 0 }}>ห้องรับรอง VIP</h1>
            <p style={{ marginTop: 8, fontSize: 13, color: '#c8d6e5' }}>PK8 พร้อมมอบสิทธิพิเศษแด่ท่านสมาชิกคนสำคัญ ด้วยเอกสิทธิ์เหนือระดับ</p>
          </div>
        </div>

        {/* Tabs (เลื่อนแนวนอน) */}
        <div style={{ background: '#0d1f3c', borderBottom: '1px solid #1e3560', display: 'flex', gap: 2, padding: '0 8px', overflowX: 'auto', whiteSpace: 'nowrap' }}>
          {tabs.map(t => (
            <button key={t.key} onClick={() => this.setState({ activeTab: t.key, openFaq: null })} style={tBtn(t.key)}>
              {t.label}
            </button>
          ))}
        </div>

        {/* ABOUT */}
        {activeTab === 'about' && (
          <div>
            <div style={{ background: '#fff', color: '#222', padding: '26px 20px' }}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>ร่วมเป็น VIP กับ PK8</div>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: '#0d2348', margin: '0 0 14px', lineHeight: 1.4 }}>
                พบกับประสบการณ์สุดพิเศษ โปรโมชั่นพิเศษ ของขวัญ และเงินคืน มากกว่าใคร!
              </h2>
              <img src="https://s3.newworld.center/image/be7f9c94-cdbe-4b63-95f8-f8893b9e539d.webp" alt="VIP" style={{ width: '100%', borderRadius: 12, margin: '4px 0 16px', boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }} />
              <p style={{ fontSize: 13.5, lineHeight: 1.9, color: '#444', marginBottom: 10 }}>ในฐานะที่ PK8 เป็นเว็บไซต์เกมออนไลน์รายใหญ่ที่สุดของเอเชีย PK8 ไม่เคยหยุดมอบสิ่งที่ดีที่สุดแก่ท่าน</p>
              <p style={{ fontSize: 13.5, lineHeight: 1.9, color: '#444' }}>โปรแกรม VIP มี 5 ระดับ: Bronze, Silver, Gold, Platinum และ Diamond แต่ละระดับมาพร้อมสิทธิพิเศษที่แตกต่างกัน</p>
            </div>
            <div style={{ padding: '28px 16px', background: 'linear-gradient(180deg,#0a1628,#0d2348)' }}>
              <h2 style={{ textAlign: 'center', fontSize: 17, fontWeight: 700, marginBottom: 22 }}>ขั้นต่ำการฝากเงินของ VIP แต่ละระดับ</h2>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 14 }}>
                {tiers.map(tier => (
                  <div key={tier.key} style={{ textAlign: 'center', background: 'rgba(255,255,255,0.03)', border: '1px solid #1e3560', borderRadius: 12, padding: '16px 8px' }}>
                    <img src={tier.img} alt={tier.label} style={{ width: 72, height: 72, objectFit: 'contain', marginBottom: 8 }} />
                    <div style={{ fontSize: 12, color: '#8aaccc', marginBottom: 4 }}>{tier.label}</div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: tier.color }}>{tier.amount}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* UPGRADE */}
        {activeTab === 'upgrade' && (
          <div style={{ padding: '24px 16px', background: '#0a1628' }}>
            <h2 style={{ fontSize: 17, fontWeight: 700, marginBottom: 16, textAlign: 'center' }}>เงื่อนไขการปรับระดับ</h2>
            {tiers.map((tier, ti) => (
              <div key={tier.key} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid #1e3560', borderRadius: 12, padding: '14px 16px', marginBottom: 12 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                  <img src={tier.icon} alt={tier.label} style={{ width: 34, height: 34 }} />
                  <span style={{ color: tier.color, fontWeight: 700, fontSize: 15 }}>{tier.label}</span>
                </div>
                {upgradeRows.map((row, ri) => (
                  <div key={ri} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '8px 0', borderTop: ri > 0 ? '1px solid #1a2e50' : 'none' }}>
                    <span style={{ color: '#8aaccc', fontSize: 12.5, lineHeight: 1.4 }}>{row.label}</span>
                    <span style={{ color: '#e8f0fe', fontSize: 13, fontWeight: 600, textAlign: 'right', flex: '0 0 auto' }}>{row.values[ti]}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

        {/* BENEFITS — ตารางเลื่อนแนวนอน */}
        {activeTab === 'benefits' && (
          <div style={{ padding: '20px 12px', background: '#0a1628' }}>
            <p style={{ textAlign: 'center', fontSize: 12, color: '#8aaccc', marginBottom: 12 }}>← เลื่อนซ้าย-ขวาเพื่อดูทุกระดับ →</p>
            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <table style={{ borderCollapse: 'collapse', fontSize: 12, minWidth: 560 }}>
                <thead>
                  <tr>
                    <th style={{ width: 150, padding: '10px 12px', textAlign: 'left', background: '#0d2348', borderBottom: '2px solid #1e3560', position: 'sticky', left: 0, zIndex: 2 }} />
                    {tiers.map(t => (
                      <th key={t.key} style={{ padding: '12px 10px', textAlign: 'center', background: '#0d2348', borderBottom: '2px solid #1e3560' }}>
                        <img src={t.icon} alt={t.label} style={{ width: 36, height: 36, display: 'block', margin: '0 auto 4px' }} />
                        <div style={{ color: t.color, fontWeight: 700, fontSize: 11 }}>{t.label}</div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {benefitRows.map((group, gi) => (
                    <React.Fragment key={gi}>
                      <tr>
                        <td colSpan={6} style={{ padding: '9px 12px', background: '#0e2040', color: '#f5a623', fontWeight: 700, fontSize: 12, borderTop: '1px solid #1e3560' }}>{group.group}</td>
                      </tr>
                      {group.rows.map((row, ri) => (
                        <tr key={ri} style={{ background: ri % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent' }}>
                          <td style={{ padding: '9px 12px', color: row.sub ? '#8aaccc' : '#c8d6e5', borderBottom: '1px solid #1a2e50', paddingLeft: row.sub ? 22 : 12, position: 'sticky', left: 0, background: '#0a1628', fontSize: 11.5 }}>{row.label}</td>
                          {row.values.map((v, vi) => (
                            <td key={vi} style={{ padding: '9px 10px', textAlign: 'center', color: v === '-' ? '#3a5070' : '#e8f0fe', borderBottom: '1px solid #1a2e50', fontSize: 11.5 }}>{v}</td>
                          ))}
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* FAQ */}
        {activeTab === 'faq' && (
          <div style={{ padding: '24px 16px', background: '#0a1628' }}>
            {faqs.map((f, i) => (
              <div key={i} style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid #1e3560', borderRadius: 10, marginBottom: 10, overflow: 'hidden' }}>
                <button onClick={() => this.setState(p => ({ openFaq: p.openFaq === i ? null : i }))}
                  style={{ width: '100%', textAlign: 'left', background: 'none', border: 'none', color: '#fff', fontFamily: 'inherit', fontSize: 14, fontWeight: 600, padding: '14px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                  <span>{f.q}</span><span style={{ color: '#f5a623', fontSize: 18 }}>{openFaq === i ? '−' : '+'}</span>
                </button>
                {openFaq === i && <div style={{ padding: '0 16px 14px', color: '#c8d6e5', fontSize: 13, lineHeight: 1.8 }}>{f.a}</div>}
              </div>
            ))}
          </div>
        )}

        {/* REFERRAL */}
        {activeTab === 'referral' && (
          <div style={{ padding: '40px 24px', background: '#0a1628', textAlign: 'center' }}>
            <p style={{ fontSize: 15, color: '#c8d6e5', lineHeight: 1.9 }}>แนะนำเพื่อนมาเป็นสมาชิก PK8 รับโบนัสและสิทธิพิเศษมากมาย</p>
            <button onClick={() => { window.location.href = '/profile'; }}
              style={{ marginTop: 16, background: 'linear-gradient(135deg,#f5a623,#ffce5a)', color: '#0a1628', border: 'none', borderRadius: 10, padding: '13px 28px', fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
              ไปหน้าแนะนำเพื่อน
            </button>
          </div>
        )}
      </div>
    );
  }

  render() {
    // แยกหน้า mobile กับ desktop — มือถือใช้ renderMobile, เดสก์ท็อปใช้ของเดิม
    if (window.innerWidth <= 760) {
      return this.renderMobile();
    }

    const { activeTab, openFaq } = this.state;
    const tabs = [
      { key: 'about',    label: 'เกี่ยวกับ' },
      { key: 'upgrade',  label: 'ปรับระดับ' },
      { key: 'benefits', label: 'สิทธิประโยชน์' },
      { key: 'faq',      label: 'คำถามที่พบบ่อย' },
      { key: 'referral', label: 'แนะนำเพื่อน' },
    ];

    const tabStyle = (key) => ({
      background: 'none', border: 'none', cursor: 'pointer',
      padding: '14px 20px', fontSize: 14, fontFamily: 'inherit',
      color: activeTab === key ? '#f5a623' : '#8aaccc',
      borderBottom: activeTab === key ? '2px solid #f5a623' : '2px solid transparent',
      fontWeight: activeTab === key ? 700 : 400,
      transition: 'all .2s',
    });

    return (
      <div style={{ background: '#0a1628', minHeight: '100vh', fontFamily: 'Noto Sans Thai, sans-serif', color: '#fff' }}>

        {/* ── Hero Banner ── */}
        <div style={{ position: 'relative', height: 320, overflow: 'hidden', background: 'linear-gradient(135deg, #051030 0%, #0d2348 60%, #1a3a6e 100%)' }}>
          <img src={`${CDN2}/top-banner.jpg`} alt="VIP Banner"
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.85 }} />
          <div style={{ position: 'relative', zIndex: 2, padding: '60px 48px' }}>
            <div style={{ fontSize: 14, color: '#f5a623', letterSpacing: 2, marginBottom: 6 }}>Supreme</div>
            <h1 style={{ fontSize: 36, fontWeight: 800, margin: 0, lineHeight: 1.2 }}>ห้องรับรอง VIP</h1>
            <p style={{ marginTop: 12, fontSize: 14, color: '#c8d6e5', maxWidth: 420 }}>
              PK8พร้อมมอบสิทธิพิเศษแด่ท่านสมาชิกคนสำคัญ ด้วยเอกสิทธิ์ที่เหนือระดับสำหรับสมาชิก VIP ทุกท่าน
            </p>
          </div>
        </div>

        {/* ── Tab Nav ── */}
        <div style={{ background: '#0d1f3c', borderBottom: '1px solid #1e3560', display: 'flex', gap: 4, padding: '0 32px', flexWrap: 'wrap' }}>
          {tabs.map(t => (
            <button key={t.key} onClick={() => this.setState({ activeTab: t.key, openFaq: null })}
              style={tabStyle(t.key)}>
              {t.label}
            </button>
          ))}
        </div>

        {/* ════════════════════════════════════
            TAB: เกี่ยวกับ
        ════════════════════════════════════ */}
        <div style={this.sec('about')}>

          {/* About */}
          <div style={{ background: '#fff', color: '#222' }}>
            <div style={{ maxWidth: 1100, margin: '0 auto', padding: '48px 32px', display: 'flex', gap: 48, alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 280 }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>ร่วมเป็น VIP กับ PK8</div>
                <h2 style={{ fontSize: 20, fontWeight: 800, color: '#0d2348', margin: '0 0 16px' }}>
                  พบกับประสบการณ์สุดพิเศษที่ไม่เหมือนใคร โปรโมชั่นพิเศษ ของขวัญ และเงินคืน มากกว่าใคร!
                </h2>
                <p style={{ fontSize: 14, lineHeight: 1.9, color: '#444', marginBottom: 12 }}>
                  ในฐานะที่ PK8เป็นเว็บไซต์เกมออนไลน์รายใหญ่ที่สุดของเอเชีย PK8ไม่เคยที่จะหยุดมอบสิ่งที่ดีที่สุดแก่ท่าน ตลอดจนถึงมาตรฐานการบริการของเรา
                </p>
                <p style={{ fontSize: 14, lineHeight: 1.9, color: '#444', marginBottom: 12 }}>
                  โปรแกรม VIP ประกอบด้วย 5 ระดับ ได้แก่ Bronze, Silver, Gold, Platinum และ Diamond แต่ละระดับมาพร้อมสิทธิพิเศษที่แตกต่างกัน
                </p>
                <p style={{ fontSize: 14, lineHeight: 1.9, color: '#444' }}>
                  เราสนับสนุนให้สมาชิกทำกำไรด้วยโปรโมชั่นพิเศษจาก PK8โดยเฉพาะสมาชิก VIP เพราะความพึงพอใจของคุณคือจุดประสงค์หลักของเรา
                </p>
              </div>
              <div style={{ flex: '0 0 360px', minWidth: 260 }}>
                <img src={`https://s3.newworld.center/image/be7f9c94-cdbe-4b63-95f8-f8893b9e539d.webp`} alt="VIP"
                  style={{ width: '100%', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.15)' }} />
              </div>
            </div>
          </div>

          {/* VIP Tiers */}
          <div style={{ background: 'linear-gradient(180deg, #0a1628 0%, #0d2348 100%)', padding: '56px 32px' }}>
            <h2 style={{ textAlign: 'center', fontSize: 20, fontWeight: 700, marginBottom: 40 }}>
              ขั้นต่ำการฝากเงินของ VIP แต่ละระดับ
            </h2>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 28, flexWrap: 'wrap', maxWidth: 860, margin: '0 auto' }}>
              {tiers.map((tier, idx) => (
                <div key={tier.key} style={{ textAlign: 'center', flex: '0 0 130px' }}>
                  <img src={tier.img} alt={tier.label}
                    style={{ width: idx === 2 ? 110 : 88, height: idx === 2 ? 110 : 88, objectFit: 'contain', filter: 'drop-shadow(0 4px 16px rgba(0,0,0,0.5))', marginBottom: 12 }} />
                  <div style={{ fontSize: 12, color: '#8aaccc', marginBottom: 4 }}>{tier.label}</div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: tier.color }}>{tier.amount}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Testimonials */}
          <div style={{ background: '#0d1f3c', padding: '56px 32px' }}>
            <h2 style={{ textAlign: 'center', fontSize: 20, fontWeight: 700, marginBottom: 36 }}>เสียงจากสมาชิก VIP</h2>
            <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', justifyContent: 'center', maxWidth: 1000, margin: '0 auto' }}>
              {[
                { name: 'Prajak S.', stars: 5, text: 'เพลิดเพลินได้ทุกที่ทุกเวลา PK8VIP ทำให้ทุกช่วงเวลาพิเศษยิ่งขึ้น!' },
                { name: 'Manoon T.', stars: 5, text: 'ผู้จัดการบัญชีชั้นนำที่มีคะแนน 100% บริการดีมาก ดูแลอย่างใส่ใจ' },
                { name: 'Siriporn W.', stars: 5, text: 'ต้องมีสำหรับ High Roller! รางวัลพิเศษของ PK8ไม่มีใครเทียบได้' },
                { name: 'Chaiwat P.', stars: 5, text: 'บริการฝากถอน Crypto ระดับมืออาชีพ สะดวกรวดเร็วมาก' },
              ].map((t, i) => (
                <div key={i} style={{ flex: '0 0 210px', background: '#0a1628', borderRadius: 10, padding: 18, border: '1px solid #1e3560' }}>
                  <div style={{ marginBottom: 8 }}>{this.renderStars(t.stars)}</div>
                  <p style={{ fontSize: 13, lineHeight: 1.7, color: '#c8d6e5', marginBottom: 10 }}>"{t.text}"</p>
                  <div style={{ fontSize: 12, color: '#f5a623', fontWeight: 700 }}>— {t.name}</div>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* ════════════════════════════════════
            TAB: ปรับระดับ
        ════════════════════════════════════ */}
        <div style={this.sec('upgrade')}>
          <div style={{ background: '#fff', color: '#222', padding: '56px 32px' }}>
            <div style={{ maxWidth: 820, margin: '0 auto' }}>
              <h2 style={{ fontSize: 20, fontWeight: 800, color: '#0d2348', marginBottom: 6 }}>เส้นทางการเป็น VIP PK8</h2>
              <h3 style={{ fontSize: 15, fontWeight: 600, color: '#f5a623', marginBottom: 24 }}>ขั้นตอนการเข้าร่วม PK8VIP</h3>
              <ol style={{ paddingLeft: 20, lineHeight: 2.4, fontSize: 14, color: '#444', marginBottom: 36 }}>
                <li>สมาชิกทั่วไปสามารถได้รับการเลื่อนระดับเป็นสมาชิก VIP โดยอัตโนมัติหลังจากทำตามข้อกำหนดการฝากเงินภายในระยะเวลาที่กำหนด</li>
                <li>อนุญาตให้ระบบตรวจสอบและอัปเดตข้อมูลของคุณภายใน 2 วันทำการ</li>
                <li>เพลิดเพลินไปกับรางวัลวีไอพีของคุณ!</li>
              </ol>
              <p style={{ fontSize: 14, lineHeight: 1.8, color: '#555', marginBottom: 10 }}>
                เพื่อความปลอดภัยของคุณ คุณจะต้องให้รายละเอียดที่จำเป็นทั้งหมดตามที่ระบุไว้ในนโยบายการเลื่อนระดับ VIP ทีมงานจะใช้เวลาสูงสุด 2 วันทำการในการตรวจสอบข้อมูล
              </p>
            </div>
          </div>

          {/* Upgrade table */}
          <div style={{ background: '#0a1628', padding: '48px 16px' }}>
            <div style={{ maxWidth: 1000, margin: '0 auto', overflowX: 'auto' }}>
              <h3 style={{ textAlign: 'center', fontSize: 18, fontWeight: 700, marginBottom: 32 }}>เกณฑ์เลื่อนและรักษาระดับ</h3>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr>
                    <th style={{ padding: '12px 16px', textAlign: 'left', background: '#0d2348', borderBottom: '2px solid #1e3560' }} />
                    {tiers.map(t => (
                      <th key={t.key} style={{ padding: '14px 12px', textAlign: 'center', background: '#0d2348', borderBottom: '2px solid #1e3560' }}>
                        <img src={t.icon} alt={t.label} style={{ width: 40, height: 40, display: 'block', margin: '0 auto 6px' }} />
                        <div style={{ color: t.color, fontWeight: 700 }}>{t.label}</div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {upgradeRows.map((row, ri) => (
                    <tr key={ri} style={{ background: ri % 2 === 0 ? 'rgba(255,255,255,0.03)' : 'transparent' }}>
                      <td style={{ padding: '12px 16px', color: '#c8d6e5', borderBottom: '1px solid #1a2e50' }}>{row.label}</td>
                      {row.values.map((v, vi) => (
                        <td key={vi} style={{ padding: '12px', textAlign: 'center', color: tiers[vi].color, fontWeight: 600, borderBottom: '1px solid #1a2e50' }}>{v}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* ════════════════════════════════════
            TAB: สิทธิประโยชน์
        ════════════════════════════════════ */}
        <div style={this.sec('benefits')}>
          {this.renderBenefitsTable()}
        </div>

        {/* ════════════════════════════════════
            TAB: คำถามที่พบบ่อย
        ════════════════════════════════════ */}
        <div style={this.sec('faq')}>
          <div style={{ background: '#fff', color: '#222', padding: '56px 32px' }}>
            <div style={{ maxWidth: 760, margin: '0 auto' }}>
              <h2 style={{ fontSize: 20, fontWeight: 800, color: '#0d2348', marginBottom: 32, textAlign: 'center' }}>
                คำถามที่พบบ่อย
              </h2>
              {faqs.map((faq, i) => (
                <div key={i} style={{ borderBottom: '1px solid #e8edf2', marginBottom: 4, borderRadius: openFaq === i ? 8 : 0, overflow: 'hidden' }}>
                  <button
                    onClick={() => this.setState({ openFaq: openFaq === i ? null : i })}
                    style={{
                      width: '100%', background: openFaq === i ? '#f0f5ff' : 'none',
                      border: 'none', cursor: 'pointer', padding: '16px 20px',
                      textAlign: 'left', fontSize: 14, fontWeight: 700, color: '#0d2348',
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      fontFamily: 'inherit',
                    }}
                  >
                    <span>{faq.q}</span>
                    <span style={{ fontSize: 16, color: '#f5a623', transform: openFaq === i ? 'rotate(180deg)' : 'none', transition: '.2s', display: 'inline-block' }}>▼</span>
                  </button>
                  {openFaq === i && (
                    <div style={{ padding: '0 20px 16px', fontSize: 14, lineHeight: 1.8, color: '#555', background: '#f0f5ff' }}>
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ════════════════════════════════════
            TAB: แนะนำเพื่อน
        ════════════════════════════════════ */}
        <div style={this.sec('referral')}>
          <div style={{ background: 'linear-gradient(135deg, #0d2348, #1a3a6e)', minHeight: 400, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', padding: '80px 32px', textAlign: 'center' }}>
            <div style={{ fontSize: 56, marginBottom: 20 }}>🎁</div>
            <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 12 }}>แนะนำเพื่อนรับโบนัส</h2>
            <p style={{ color: '#8aaccc', fontSize: 14, marginBottom: 28, maxWidth: 480 }}>
              แนะนำเพื่อนให้มาร่วมสนุกกับ PK8รับโบนัสพิเศษทันที ยิ่งแนะนำมาก ยิ่งได้รับมาก
            </p>
            <button style={{
              background: 'linear-gradient(135deg, #f5a623, #e8960f)',
              color: '#fff', border: 'none', borderRadius: 8,
              padding: '14px 40px', fontSize: 15, fontWeight: 700,
              cursor: 'pointer', boxShadow: '0 4px 16px rgba(245,166,35,0.4)',
            }}>
              แชร์ลิงก์แนะนำเพื่อน
            </button>
          </div>
        </div>

        {/* ── CTA (แสดงทุก tab) ── */}
        <div style={{ background: '#0a1628', padding: '40px 32px', textAlign: 'center', borderTop: '1px solid #1e3560' }}>
          <p style={{ color: '#8aaccc', fontSize: 13 }}>
            มีคำถาม? ติดต่อทีมงาน VIP ของเราได้ตลอด 24 ชั่วโมง
          </p>
        </div>

      </div>
    );
  }
}

export default VipPage;
